// extracted by mini-css-extract-plugin
export default {"assignedTask":"AssignedTask_assignedTask__00gk8","task":"AssignedTask_task__TT9m2","name":"AssignedTask_name__tIQ74","status":"AssignedTask_status__KzpMd"};